import cmaApi from "../../../../../api/cmaApi";
import { appRoutes } from "../../../../../routes/routes";
import LandingList from "../../LandingList";

const FaqList = () => (
  <LandingList
    config={{
      title: "CMA · Câu hỏi thường gặp",
      listPath: appRoutes.CMA.LANDING.FAQ.LIST,
      addPath: appRoutes.CMA.LANDING.FAQ.ADD,
      queryKey: "cma_landing_faq",
      getList: cmaApi.getLandingFaq,
      editItem: cmaApi.editLandingFaq,
      deleteItem: cmaApi.deleteLandingFaq,
      titleField: "question_vi",
      subtitleField: "answer_vi",
    }}
  />
);

export default FaqList;
